import React, { Component } from 'react';
import ZoneInput from '../inputs/ZoneInput';
import { KEY_TAB, KEY_ENTER } from '../../../constants/keyboardCodes';
import { getDisplayZone } from 'common/types/GetDisplayZone';

class ZoneEditor extends Component {
    constructor(props) {
        super(props);
        this.zoneInputRef = React.createRef();
        this.focus = this.focus.bind(this);
        this.handleOnTab = this.handleOnTab.bind(this);
        this.handleOnTabBack = this.handleOnTabBack.bind(this);
        this.handleOnEnter = this.handleOnEnter.bind(this);
        this.onZoneSelected = this.onZoneSelected.bind(this);
        this.getValue = this.getValue.bind(this);
        this.handleInputCleared = this.handleInputCleared.bind(this);

        // props.value is the array field (e.g. loadZones). For unmigrated rows
        // it is null — fall back to the singular field (e.g. loadZone) via row data.
        // Do NOT fall back when props.value is [] (explicitly cleared).
        const arrayValue = Array.isArray(this.props.value)
            ? this.props.value[0]
            : this.props.value;
        const singularField = this.props.column?.colDef?.field?.replace(
            /Zones$/,
            'Zone'
        );
        const singularValue =
            this.props.value == null && singularField && this.props.data
                ? this.props.data[singularField]
                : null;
        const initialZone = arrayValue || singularValue || null;
        this._initialZone = initialZone || null;
        this._userModifiedZone = false;
        if (initialZone) {
            this.state = {
                selectedZone: { key: initialZone, name: initialZone },
            };
        } else {
            this.state = {};
        }
    }

    afterGuiAttached() {
        this.focus();
    }

    focus() {
        if (this.zoneInputRef.current) {
            this.zoneInputRef.current.focus();
        }
    }

    handleOnTab() {
        this.props.api.tabToNextCell();
    }

    handleOnTabBack() {
        this.props.api.tabToPreviousCell();
    }

    handleOnEnter() {
        this.props.stopEditing();
    }

    getValue() {
        if (this._userModifiedZone) {
            // User deliberately selected or cleared a zone
            return this.state.selectedZone
                ? [this.state.selectedZone.name]
                : [];
        }
        // Editor closed without any interaction — return the original value unchanged
        if (this._initialZone) {
            return [this._initialZone];
        }
        return [];
    }

    isPopup() {
        return true;
    }

    onZoneSelected(zone, keyCode, shift) {
        this._userModifiedZone = true;
        this.setState(
            {
                selectedZone: zone,
            },
            () => {
                switch (keyCode) {
                    case KEY_TAB:
                        if (!shift) {
                            this.handleOnTab();
                        } else {
                            this.handleOnTabBack();
                        }
                        break;

                    case KEY_ENTER:
                    default:
                        //assume treated as enter, such as mouse click selection
                        this.handleOnEnter();
                        break;
                }
            }
        );
    }

    handleInputCleared() {
        this._userModifiedZone = true;
        this.setState({ selectedZone: null });
    }

    render() {
        return (
            <div className="multiple-location-select">
                <div className="multiple-location-select-items">
                    <div className="multipleLocationSelect-input-container">
                        <div className="multipleLocationSelect-input">
                            <ZoneInput
                                headerName={this.props.column.colDef.headerName}
                                ref={this.zoneInputRef}
                                context={this.props.context}
                                field={this.props.column.colDef.field}
                                value={this.state.selectedZone}
                                onTab={this.handleOnTab}
                                onTabBack={this.handleOnTabBack}
                                onEnter={this.handleOnEnter}
                                onZoneSelected={this.onZoneSelected}
                                shouldSelectItemOnTab={true}
                                inputClass="ag-react-container"
                                initialChar={this.props.charPress}
                                initialValue={
                                    !this.props.charPress &&
                                    this.state.selectedZone
                                        ? getDisplayZone(
                                              this.state.selectedZone.name
                                          )
                                        : undefined
                                }
                                onInputCleared={this.handleInputCleared}
                                isLastPosition={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ZoneEditor;
